<template>
  <div>
    <v-row no-gutters>
      <span class="textLight--text font-weight-medium text-h5 text-start">
        {{ $t("course.assignedCourses.assignedCourses") }}
      </span>
    </v-row>

    <v-row v-if="loading">
      <v-col>
        <assigned-course-loader />
      </v-col>
    </v-row>

    <v-row v-else-if="courses && courses.length">
      <v-col
        v-for="(course, index) in courses"
        :key="index"
        cols="12"
        sm="6"
        md="6"
        lg="4"
        xl="3"
      >
        <assigned-course-card :course="course" />
      </v-col>
    </v-row>

    <v-row v-else justify="center" align="center">
      <v-col cols="10" sm="8" lg="6">
        <empty-courses
          :heading="$t('course.noCoursesMessage')"
          :body="$t('course.contactCoordinator')"
          :isOnSide="false"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AssignedCourseCard from "../components/AssignedCourseCard.vue";
import EmptyCourses from "./EmptyCourses.vue";
import AssignedCourseLoader from "./skeleton-loaders/AssignedCourseLoader";

export default {
  components: {
    AssignedCourseLoader,
    AssignedCourseCard,
    EmptyCourses,
  },
  props: {
    data: {
      type: Array,
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      courses: [],
    };
  },
  watch: {
    data: {
      immediate: true,
      handler() {
        this.courses = this.data.map(obj => {
          let totalContents = 0;

          if (obj && obj.training && obj.training.trainingModules) {
            obj.training.trainingModules.map(module => {
              totalContents += module.trainingModuleContents.length;
            });
          }

          obj.totalContents = totalContents ? totalContents : 0;

          return obj;
        });
      },
    },
  },
};
</script>
